import { api } from "data/api";

export const fetch = (path, options = {}, prefix = 'aws') => {

  options.headers = {
    'Authorization': 'Bearer ' + window.playmotiv.user.token
  }

  if (options.body) {

    options.body = JSON.stringify(options.body);
    options.headers['Accept'] = 'application/json';
    options.headers['Content-Type'] = 'application/json';
  }

  return new Promise((resolve, reject) => {

    window
      .fetch(
        `${api[prefix].url}${path}`,
        options
      )
      .then(response => response.json())
      .then(result => {

        if (result.code || result.error || result.message) {
          console.log('Error on fetch data', result);
          reject(result)
        } else {
          resolve(result)
        }

      })
      .catch(error => {
        console.log(`Error on fetch data: ${api[prefix].url}${path}`, options, error);
        reject(error)
      })
  });
}

export const fetchCore = (path, options = {}) => fetch(path, options, 'core')